import IconCheckCircle from '@/shared/icons/NewDesign/IconCheckCircle'
import useClientSaveStatus from './useClientSaveStatus'
import { StatusDot, StatusText } from './styled-components'

const ClientSaveStatus = () => {
  const { statusKey, statusText, hasPendingSave } = useClientSaveStatus()

  return (
    <StatusText $statusKey={statusKey} role='status'>
      {hasPendingSave ? (
        <StatusDot aria-hidden='true' />
      ) : (
        <IconCheckCircle size={16} color='currentColor' aria-hidden='true' />
      )}
      {statusText}
    </StatusText>
  )
}

export default ClientSaveStatus
